<template>
  <full-container>
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form :inline="true" :model="queryParams" size="small">
        <el-form-item>
          <el-input v-model="queryParams.keyWord" placeholder="姓名/手机号/登录名" clearable>
            <el-button slot="append" icon="el-icon-search" @click="onSearch()" />
          </el-input>
        </el-form-item>
      </el-form>
      <el-button size="small" type="primary" @click="openForm()">创建账号</el-button>
    </div>

    <!--表格-->
    <el-table v-loading="loading" ref="tb" :data="datalist.Items" height="100%">
      <el-table-column prop="Name" label="姓名" min-width="120" show-overflow-tooltip />
      <el-table-column prop="Phone" label="手机号" min-width="120" show-overflow-tooltip />
      <el-table-column prop="Account" label="登录名" min-width="120" show-overflow-tooltip />
      <el-table-column label="角色" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag type="info" v-for="(item, index) in row.Roles" :key="index" size="mini">{{ item.Name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="到期日期" min-width="100">
        <span slot-scope="{ row }" :style="{ color: !row.State ? '#f56c6c' : '' }">
          {{ $utils.common.parseTime(row.ExpireDate) }}
        </span>
      </el-table-column>
      <el-table-column label="创建时间" min-width="100">
        <span slot-scope="{ row }">
          {{ $utils.common.parseTime(row.CreateTime) }}
        </span>
      </el-table-column>
      <el-table-column label="登录情况" min-width="120">
        <el-tooltip placement="top" slot-scope="{ row }">
          <div slot="content">最后登录时间<br />{{ row.LastTime }}</div>
          <label>{{ row.LastIp }}</label>
        </el-tooltip>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-dropdown>
            <el-tag size="small" :type="row.State == -1 ? 'danger' : 'primary'">
              设置
              <i class="el-icon-arrow-down" />
            </el-tag>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-action="'/api/System/User/Submit'" @click.native="openForm(row)">修改信息</el-dropdown-item>
              <el-dropdown-item v-action="'/api/System/User/ResetPassword'" @click.native="onResetPassword(row)">重置密码</el-dropdown-item>
              <el-dropdown-item v-action="'/api/System/Authorize/GetActions'" @click.native="$router.push({ path: `permit/3/${row.Id}` })">用户授权</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination slot="footer" background :page-size="queryParams.size" :total="datalist.TotalCount" @current-change="onSearch" />
  </full-container>
</template>



<script>
import formpage from './form'
export default {
  data () {
    return {
      loading: false,
      datalist: [],
      queryParams: {
        index: 1,
        size: 20,
      },
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.system.user.getList(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //编辑
    openForm (row = {}) {
      this.$layer.iframe({
        title: '用户编辑',
        area: ['600px', 'auto'],
        content: {
          content: formpage,
          parent: this,
          data: {
            _detail: {
              ...row,
              Roles: row.Roles?.map(x => x.RoleId) || []
            },
            callback: () => {
              this.loadData()
            }
          }
        }
      })
    },
    //重置密码
    onResetPassword (row) {
      this.$prompt('请输入新密码', '重置密码', {
        center: true
      }).then(({ value }) => {
        this.$apis.system.user.resetPassword({
          id: row.Id,
          value: value
        }).then(() => {
          this.$message({ message: "密码已重置", type: "success" })
        }).catch((e) => {
          this.$message.error(e.value || e)
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>
